import { type FC, useState } from "react";
import Modal from "@root/shared/components/Modal";
import { Icon } from "@root/shared/components/Icon";
import { ScoutCountTypeLabel } from "@root/clientFrontend/features/scout/components/ScoutCountTypeLabel";
import * as styles from "./styles.css";

/* eslint-disable camelcase */
type ScoutCount = {
  type_name: string;
  start_date: string;
  end_date: string;
  scout_count: number | null;
  premium_scout_count: number | null;
  national_qualifications_scout_count: number | null;
  ai_message_count: number | null;
};

type Props = {
  scout_counts: ScoutCount[];
};

export const PcScoutRemainingCountDetail: FC<Props> = ({ scout_counts }) => {
  const [isShow, setIsShow] = useState(false);

  const handleOpen = () => {
    setIsShow(true);
  };

  const handleClose = () => {
    setIsShow(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleOpen();
    }
  };

  return (
    <>
      <div className={styles.modalOpenWrapper}>
        <button
          type="button"
          className={styles.modalOpenButton}
          onClick={handleOpen}
          onKeyDown={handleKeyDown}
        >
          <span className={styles.hoverUnderline}>各種スカウトの詳細・有効期限を確認する</span>
          <Icon name="arrow-light-right" fontSize="16px" />
        </button>
      </div>
      <Modal
        isShow={isShow}
        onClose={handleClose}
        headerTitle="各種スカウトの詳細・有効期限"
        headerTitleStyle="white"
      >
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <tbody>
              <tr>
                <th className={styles.tableHeader}>有効期限</th>
                <th className={styles.tableHeader}>スカウト残数</th>
                <th className={styles.tableHeader}>
                  AIメッセージ
                  <br />
                  使用可能回数
                </th>
              </tr>
              {scout_counts.map((count, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={index} className={styles.contentsTableRow}>
                  <td className={styles.tableCell}>
                    <div>
                      {count.start_date} ~ {count.end_date}
                    </div>
                    <div className={styles.typeName}>
                      <ScoutCountTypeLabel typeName={count.type_name} />
                    </div>
                  </td>
                  <td className={styles.flexTableCell}>
                    {count.scout_count !== null ? (
                      <>
                        <p>
                          <span className={styles.boldText}>{count.scout_count}</span>通
                        </p>
                        <div className={styles.flexTableCellChild}>
                          <p>うちプレミアムスカウト{count.premium_scout_count}通</p>
                          <p>
                            うち国家資格職種希望者向け{count.national_qualifications_scout_count}通
                          </p>
                        </div>
                      </>
                    ) : (
                      <p>-</p>
                    )}
                  </td>
                  <td className={styles.tableCell}>
                    {count.ai_message_count !== null ? (
                      <p>
                        <span className={styles.boldText}>{count.ai_message_count}</span>回
                      </p>
                    ) : (
                      <p>-</p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
};
